module.exports = __webpack_public_path__ + "img/business7.4eeaac59.png";